import styled from '@emotion/styled';

export const SidebarContainer = styled.div`
  width: 5%;
  // max-width: 80px;
  min-width: 80px;
  transition: .2s ease-in all;
  background-color:white;
`

export const SidebarHeader = styled.h3`
  padding: 20px 0;
  text-align: center;
  margin-bottom: 10px;
  letter-spacing: 6px;
`

export const MenuItemContainer = styled.div``;
export const ItemContainer = styled.div``;

// Menu items -------------------------------------------------------------
export const MenuItem = styled.div`
  text-align: center;
  padding: 10px 5px;
  font-weight: 600;
  color: ${p => p.selected ? 'white' : 'blue'} ; 
  position: relative; // Dropdown Icon
  transition: .2s ease-in all;
  border-bottom:1px solid darkgray;
  background-color:${p => p.selected ? '#5c68fc' : 'white'} ; 
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  position: relative;

  &:after {
    content: "";
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid ${p => p.selected ? '#5c68fc' : 'transparent'};
    position: absolute;
    top: 30px;
    right: -10px;
    z-index:${p => p.selected ? '99999' : '0'} ; 
  }
`;

export const Icon = styled.div`
  height: 16px;
  width: 16px;
`
// Toggler -----------------------------------------------------------------------------
export const TogglerContainer = styled.div`
  position: absolute;
  width: 30%;
  bottom: 10%;
  left: 0;
  right: 0;
  margin: 0 auto;
`

export const Toggler = styled.div`
    height: 40px;
    cursor: pointer;
    position: relative; // horizontal lines
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: .25em;
      height: .1em;
      width: 100%;
      background: #fff;
      box-shadow: 
        0 .75em 0 0 #fff,
        0 1.5em 0 0 #fff;        
    }
`
export const Text = styled.p`
`